import React from 'react';
import { getSize } from './utils.js';

function c(content) {
  return ({
    size: sizeProp = "md",
    color = "currentcolor",
    children,
    ...rest
  }) => {
    const size = getSize(sizeProp);
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        "aria-hidden": true,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        ...rest
      },
      children,
      content
    );
  };
}

export { c as default };
